var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNotificationSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 7 9"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "002-notification"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 12050"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 10374",
    d: "M6.88 6.267l-.419-.273V3.621A2.929 2.929 0 003.769.733V.264a.269.269 0 00-.538 0v.469A2.929 2.929 0 00.539 3.621v2.373l-.419.273a.262.262 0 00-.12.219v1.055a.266.266 0 00.269.264h1.775a1.485 1.485 0 002.912 0h1.775A.267.267 0 007 7.541V6.486a.262.262 0 00-.12-.219zM3.5 8.473a.943.943 0 01-.9-.668h1.8a.943.943 0 01-.9.668zm2.962-1.2H.538v-.65l.419-.273a.262.262 0 00.12-.219v-2.51a2.424 2.424 0 014.846 0v2.514a.262.262 0 00.12.219l.419.273z",
    fill: "inherit"
  })))));
}

export default SvgNotificationSmall;